export const is5xxHttpStatus = (status: number): boolean => {
  return status >= 500 && status < 600;
};

export const is4xxHttpStatus = (status: number): boolean => {
  return status >= 400 && status < 500;
};
